import { useEffect, useState } from "react";
import { CounterInputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ReactComponent as GrassIcon } from "../../../../assets/svg/icons/grass.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";
import { ButtonYesOrNo } from "../../../Buttons/ButtonYesOrNo";
import { format } from "date-fns";
import { parseUtcDate } from "../../../../utils/date/formatedDate";

interface InfoPlantingProps {
  task: ITaskPlanting | undefined;
}

export default function InfoPlanting(task: InfoPlantingProps) {
  const [taskPlanting, setTaskPlanting] = useState<ITaskPlanting>();
  const hasSkipReason = taskPlanting?.skip_reason != null;

  useEffect(() => {
    setTaskPlanting(task.task);
  }, []);

  return (
    <>
      <div>
        <span>No pasto</span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <GrassIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskPlanting?.initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={`A tarefa foi iniciada?`} pointed />
        <ButtonYesOrNo
          onlyResult
          optionSelected={hasSkipReason ? "no" : "yes"}
        />
      </div>

      {hasSkipReason ? (
        <MessageBalloon text={`${taskPlanting?.skip_reason}`} answer />
      ) : (
        <>
          <MessageBalloon
            text={`${taskPlanting?.planting_type} - ${taskPlanting?.fodder_genus} - ${taskPlanting?.fodder_species} - ${taskPlanting?.seed_type} - ${taskPlanting?.vc_percentage}%VC - ${taskPlanting?.seed_quantity_kg} Kg`}
          />

          <div className="containerQuestion">
            <MessageBalloon text={`Qual o tipo de operação?`} pointed />
            <ButtonPressed
              onlyResult
              optionSelected={1}
              value={1}
              text={`${taskPlanting?.operation_type}`}
            />
          </div>

          {taskPlanting?.operation_type == "MECANIZADA" && (
            <>
              <MessageBalloon
                text={`${format(parseUtcDate(taskPlanting?.start_time) || 0, "dd/MM/yyyy - HH:mm")}`}
              />

              <MessageBalloon text={`Informar horímetro inicial`} />
              <CounterInputV2
                name="info-planting-initial-h"
                suffix="h"
                value={Number(taskPlanting?.initial_hour_meter ?? 0)}
                disabled
              />

              <ButtonPressed
                onlyResult
                optionSelected={1}
                value={1}
                text={`Horímetro final`}
              />

              <MessageBalloon
                text={`${format(parseUtcDate(taskPlanting?.end_time) || 0, "dd/MM/yyyy - HH:mm")}`}
              />

              <MessageBalloon text={`Informar horímetro final`} />
              <CounterInputV2
                name="info-planting-final-h"
                suffix="h"
                value={Number(taskPlanting?.final_hour_meter ?? 0)}
                disabled
              />
            </>
          )}
        </>
      )}
    </>
  );
}
